import { useContext } from "react";
import { store } from "../../store";

const useGlobal = () => {
  const { global, setGlobal } = useContext(store);

  return { global, setGlobal };
};

export default useGlobal;
